const checkForIframe =()=> {
    return false;
    // let iframe = document.querySelector('iframe');
    // if(!iframe) return false;
    // iframe = document.getElementById('kudoshub-editor-frame');
    // if(!iframe) return false;
    // return true;
}

export const isIframe = checkForIframe();